import React, { useEffect, useState } from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import { TextField } from "@material-ui/core";
import Notification from "../notification/Notification";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

import MaterialDialog from "../../styles/materialDialog";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import axios from "axios";

const StartBatches = ({ fetchBatches, batches }) => {
  const { t } = useTranslation("batchesPage");
  const [open, setOpen] = useState(false);

  const defaultData = {
    "count": null,
    "twofa": null
  };

  const [startData, setStartData] = useState(defaultData);
  const [disabled, setDisabled] = useState(false);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    setDisabled(false);
  }, [notification]);

  const startBatches = async (event) => {
    event.preventDefault();
    setDisabled(true);

    if (!Number.isInteger(parseInt(startData.count))) {
      setNotification({ ...notification, visible: true, type: "error", message: "Invalid count" });
      return;
    }

    let check2Fa = await check2FA(getUserInfo()["userId"], startData.twofa);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    delete startData.twofa;

    axios.get("/api/start-batches/" + batches.id + "/" + startData.count, userAuthenticationConfig(false)).
      then(response => {
        if (response.status === 200) {
          fetchBatches();
          setNotification({ ...notification, visible: true, type: "success", message: t("table.success") });
          handleClose();
        }
      }).
      catch(error => {
        setNotification({ ...notification, visible: true, type: "error", message: error.response.data.data.title });
      });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setStartData(defaultData);
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <React.Fragment>
        <DefaultButton
          className="stop-event"
          color="transparent"
          border="success"
          onClick={handleClickOpen}
        >
          {t("table.start")}
        </DefaultButton>
        <MaterialDialog
          className="stop-event"
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("table.startBatch")} {batches.name}
            </StyledDialogHead>
            <StyledDialogContent>
              <TextField
                type="text"
                id="count"
                label={t("table.count")}
                value={startData.count}
                onChange={(data) => setStartData({ ...startData, count: data.target.value.replace(/[^\d]/g, "") })}
              />
              <TextField
                id="twofa"
                label={t("table.twofa")}
                value={startData.twofa}
                onChange={(data) => setStartData({ ...startData, twofa: data.target.value })}

              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={disabled}
              >
                {t("table.cancel")}
              </DefaultButton>
              <DefaultButton
                onClick={startBatches}
                color="success"
                disabled={disabled}
              >
                {t("table.start")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </React.Fragment>
    </>
  );
};

export default StartBatches;